import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import css from '../../css/errors/topError.module.scss';
import { ReactComponent as Cross } from '../../img/common/cross.svg';
import { selectError, setTopError } from '../../slice/errorSlice';

export const TopError: React.FC = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { topError } = useSelector(selectError);
    const dispatch = useDispatch();

    useEffect(() => {
        if (topError !== null) {
            setIsOpen(true);
            setTimeout(() => {
                // 5秒後にtopErrorを自動で閉じる
                setIsOpen(false);
                setTimeout(() => {
                    // 10秒後にtopErrorを空にする。10秒待つのは、同じtopErrorが表示された時に連続して何回もerrorが表示されるのを防ぐため
                    dispatch(setTopError(null));
                }, 10000);
            }, 5000);
        } else {
            setIsOpen(false);
        }
    }, [topError, dispatch]);
    return (
        <>
            {isOpen && (
                <div className={css.error}>
                    <div>
                        <p>{topError}</p>
                        <Cross height={24} width={24} role="img" aria-label="閉じる" onClick={() => setIsOpen(false)} />
                    </div>
                </div>
            )}
        </>
    );
};
